import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

type CardTone = 'surface' | 'panel'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  tone?: CardTone
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const toneStyles: Record<CardTone, string> = {
  surface: 'bg-paper-surface',
  panel: 'bg-paper-panel',
}

const paddingStyles = {
  none: '',
  sm: 'p-3',
  md: 'p-5',
  lg: 'p-6',
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, tone = 'surface', padding = 'md', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('rounded-card border border-line-soft', toneStyles[tone], paddingStyles[padding], className)}
        {...props}
      >
        {children}
      </div>
    )
  },
)
Card.displayName = 'Card'

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex items-center justify-between gap-3', className)} {...props} />
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('text-[14px] font-semibold text-ink', className)} {...props} />
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('mt-1 text-[13px] leading-relaxed text-ink-muted', className)} {...props} />
}
